import { Component, OnInit } from '@angular/core';
import { NgModule } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ApiService } from '../../../app/servicios/api/api.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  usuario:string = "";
  correo:string = "";
  nombre:string = "";
  rolUsusario:string = "";
  tipoUsuario:string = "";
  neceCambioClave:string = "";
  caratulaOk = "";

  constructor(private api:ApiService, private router:Router, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.usuario = localStorage.getItem('usuario');
    this.correo = localStorage.getItem('correo');
    this.nombre = localStorage.getItem('nombre');
    this.rolUsusario = localStorage.getItem('rol')
    this.tipoUsuario = localStorage.getItem('tipo');
    this.neceCambioClave = localStorage.getItem('nuevaClave');
  }

  verMenuDirectorio(){
    if(this.tipoUsuario=='DANE'&&(this.rolUsusario=='Administrador'||this.rolUsusario=='Tematico')) return true; else false;
  }

  verMenuUsuarios(){
    if(this.tipoUsuario=='DANE'&&(this.rolUsusario=='Administrador')) return true; else false;
  }

  verMenuParametricas(){
    if(this.tipoUsuario=='DANE'&&(this.rolUsusario=='Administrador'||this.rolUsusario=='Tematico')) return true; else false;
  }

  verMenuCalendario(){
    if(this.tipoUsuario=='DANE'&&(this.rolUsusario=='Administrador'||this.rolUsusario=='Tematico')) return true; else false;
  }

  verMenuAnalisis(){
    if(this.tipoUsuario=='DANE'&&(this.rolUsusario=='Administrador'||this.rolUsusario=='Tematico')) return true; else false;
  }

  verMenuAdmininfo(){
    if(this.tipoUsuario=='DANE'&&(this.rolUsusario=='Administrador')) return true; else false;
  }

  verMenuOperativo(){
    if(this.tipoUsuario=='DANE'&&(this.rolUsusario=='Administrador'||this.rolUsusario=='Tematico'||this.rolUsusario=='Operativo')) return true; else false;
  }

  verMenuIndicadores(){
    if(this.tipoUsuario=='DANE'&&(this.rolUsusario=='Administrador'||this.rolUsusario=='Tematico')) return true; else false;
  }

  verMenuCuadrossalida(){
    if(this.tipoUsuario=='DANE'&&(this.rolUsusario=='Administrador'||this.rolUsusario=='Tematico'||this.rolUsusario=='Operativo')) return true; else false;
  }

  verMenuDatosBasicos(){
    if((this.tipoUsuario=='CHV'||this.tipoUsuario=='FIVI')&&this.rolUsusario!='Supersolidaria') return true; else false;
  }

  verMenuCargueMasivo(){
    if((this.tipoUsuario=='CHV'||this.tipoUsuario=='FIVI')) return true; else false;
  }

  verMenuNovedades(){
    if((this.tipoUsuario=='CHV'||this.tipoUsuario=='FIVI')&&this.rolUsusario!='Supersolidaria') return true; else false;
  }

  verMenuConsultarReportes(){
    if((this.tipoUsuario=='CHV'||this.tipoUsuario=='FIVI')) return true; else false;
  }

  goDirectorio(){
    this.router.navigate(['directorio']);
  }

  goUsuarios(){
    this.router.navigate(['usuarios']);
  }

  goParametricas(){
    this.router.navigate(['parametricas']);
  }

  goCalendario(){
    this.router.navigate(['calendario']);
  }

  irAnalisis(){
    this.router.navigate(['analisis']);
  }

  irAdministracionInfo(){
    this.router.navigate(['admininfo']);
  }

  irOperativo(){
    this.router.navigate(['operativo']);
  }

  irIndicadores(){
    this.router.navigate(['indicadores']);
  }

  irCuadrosSalida(){
    this.router.navigate(['CuadrosSalida']);
  }

  goCaratula(){
    if (this.neceCambioClave == "true"){
      this.router.navigate(['cambiarclave']);
    } else{
      this.router.navigate(['caratula']);
    }
  }

  goCargueMasivo(){
    this.caratulaOk = localStorage.getItem('caratulaOk');
    if (this.neceCambioClave == "true"){
      this.router.navigate(['cambiarclave']);
    }else if (Number(this.caratulaOk)==1){
      this.toastr.warning('Debe guardar datos básicos.', 'Importante!');
    }else {
      if (this.tipoUsuario == "CHV"){
        this.router.navigate(['carguemasivo']);
      } else if (this.tipoUsuario == "Supersolidaria"){
        this.router.navigate(['carguemasivosuper']);
      }  else if (this.tipoUsuario == "FIVI"){
        this.router.navigate(['carguemasivofivi']);
      }
    }
  }

  goNovedades(){
    this.caratulaOk = localStorage.getItem('caratulaOk');
    if (this.neceCambioClave == "true"){
      this.router.navigate(['cambiarclave']);
    }else if (Number(this.caratulaOk)==1){
      this.toastr.warning('Debe guardar datos básicos.', 'Importante!');
    }else {
      this.router.navigate(['novedades']);
    }
  }

  goConsultaReporte(){
    if (this.neceCambioClave == "true"){
      this.router.navigate(['cambiarclave']);
    } else {
      this.router.navigate(['consultareporte']);
    }
  }

}
